/**
 * NAT-2860: a login refused because another tab signed someone in or out while it was pending.
 * The credentials were not the problem, so the login view says so and keeps the password.
 */
export class LoginInterruptedError extends Error {
  constructor(message = 'Another tab changed the session while the login was pending') {
    super(message);
    this.name = 'LoginInterruptedError';
  }
}
